import styled, { css } from 'styled-components';

import { Color } from '../../../constants/Colors';
import { Typography } from '../../../constants/Typographies';

export const Wrapper = styled.table`
  margin-top: 30px;
  display: flex;
  width: 100%;
  table-layout: fixed;
  display: inline-table;
  border: 2px solid ${Color.MYSTIC};
`;

export const StyledHead = styled.thead``;

export const StyledRow = styled.tr``;

const StyledData = css`
  border: 2px solid ${Color.MYSTIC};
  text-align: center;
  padding: 8px;
  vertical-align: middle;
`;

export const StyledTitle = styled.td`
  ${StyledData}
  ${Typography.L_BOLDER}
  color: ${Color.CLOUD_BURST};
  background-color: ${Color.ZIRCON};
`;

export const StyledContent = styled.td`
  ${StyledData}
  background-color: ${({ isMaximum }) => isMaximum && Color.PASTEL_GREEN};
`;

export const ImageWrapper = styled.div`
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Description = styled.p`
  ${Typography.XS};
  color: ${Color.CLOUD_BURST};
`;

export const Icon = styled.span`
  margin-right: 4px;
`;
